import axios from "axios";
import _router from '../router'
import store from '../store'

// 不需要登录的接口数组

// uni-app请求封装
export default class Request {
    // 普通请求
    http(router, data = {}, method, show_loading = true) {
        // 返回promise
        return new Promise((resolve, reject) => {
            show_loading && store.commit('loadingAdd')
            // 请求
            axios({
                method: method,
                url: router,
                data: data,
                headers: {
                    "Authorization": 'Bearer ' + localStorage.getItem("Access-Token"),
                    "content-type": 'application/json;charset=UTF-8'
                }
            })
                .then((res) => {
                    if (!res.ok) {

                    }
                    resolve(res.data)
                })
                .catch(function (error) {
                    // if (error.response.status == 401) {
                    //     _router.push('/login')
                    // }else {
                    //     _router.push('/error')
                    // }
                })
                .finally(() => {
                    show_loading && store.commit('loadingSubtract')
                })
        })
    }

    get_http(router, data = {}, method) {
        return new Promise((resolve, reject) => {
            store.commit('loadingAdd')
            // 请求
            axios.get(router, {
                params: data,
                headers: {
                    "Authorization": 'Bearer ' + localStorage.getItem("Access-Token")
                }
            })
                .then(function (res) {
                    resolve(res.data)
                })
                .catch(function (error) {
                    console.log(error)
                })
                .finally(() => {
                    store.commit('loadingSubtract')
                })
        })
    }

}



// WEBPACK FOOTER //
// ./src/utils/request.js